import Jsona from 'jsona';

const dataFormatter = new Jsona();
export const jsonApiTransformer = {
  // Transform JSON:API response to Pinia-ORM format
  deserialize(jsonApiData) {
    try {
      console.log('zzzzzzz', jsonApiData);
      const x = dataFormatter.deserialize(jsonApiData);
      console.log('xxxxxxxxxxxxxxxxxxx', x);
      return x;// dataFormatter.deserialize(jsonApiData);
    } catch (error) {
      console.log('ERRxxxxxxxxxxxxxxxxxxx', error);
      console.error('JSON:API deserialization error:', error);
      return null;
    }
  },

  // Transform Pinia-ORM data to JSON:API format
  serialize(data, type) {
    try {
      const jsonApiData = {
        data: {
          type,
          attributes: { ...data },
        },
      };

      // Remove id from attributes if it exists
      if (jsonApiData.data.attributes.id) {
        jsonApiData.data.id = jsonApiData.data.attributes.id.toString();
        delete jsonApiData.data.attributes.id;
      }

      return jsonApiData;
    } catch (error) {
      console.error('JSON:API serialization error:', error);
      return data;
    }
  },
};
